import _includes from "lodash/includes"

export const selectBillFromStorage = () => {
  const itemFromStorage = window.localStorage.getItem("selectBill")
  const isValidObject = itemFromStorage && _includes(itemFromStorage, "{")
  return isValidObject ? JSON.parse(itemFromStorage) : null
}



// WEBPACK FOOTER //
// ./src/services/utils/selectBillFromStorage.js